import createModule from "../createModule"
import { Creators as notificationsCreators } from "modules/notifications/model"
import { Creators as DialogCreators } from "modules/dialog/model"
import { Creators } from "./model"
import view from "./view"
import { getPortfolioDetails, getModelId, getFiles, getUploadConfig, getScanResult, getUploadOption, getUploadDateTime, getUploadedFiles, getOverlappingDates, getExperimentId } from "./selectors"
import { getSteps } from "./selectors/steps"
import { getActiveStepFromParams } from "helpers/upload-steps"
import withUrlParams from "hocs/withUrlParams"
import withNavigate from "hocs/withNavigate"
import withOutletContext from "hocs/withOutletContext"
import { MODELS_QUERY } from "resources/models"

export default withUrlParams(withNavigate(withOutletContext(createModule({
  view,
  externalProps: (state, props) => ({
    portfolioId: state.global.selected.portfolio,
    account: state.global.selected.account,
    experimentId: getExperimentId(state, props),
    modelId: getModelId(state, props),
  }),
  required: ["account", "portfolioId"],
  data: [{
    resource: "experiment",
    as: null,
    url: ({ experimentId, portfolioId }) => {
      if (!experimentId) return null
      return ({
        id: `${experimentId}${portfolioId}`,
        query: `query ($portfolioId: String!, $experimentId: String!) {
          portfolio (id: $portfolioId) {
            experiment (id: $experimentId) {
              id name
            }
          }
        }`,
        variables: { experimentId, portfolioId },
      })
    },
  }, {
    resource: "portfolio",
    url: ({ account, portfolioId }) => `/api/${account}/p/${portfolioId}`,
  }, {
    ...MODELS_QUERY,
    as: null,
  }, {
    resource: "portfolioModelMeta",
    url: ({ account, portfolioId, modelId }) => {
      if (!modelId) {
        return null
      }
      return `/api/${account}/m/${modelId}/r/portfolio/${portfolioId}`
    },
  }],
  mapStateToProps: (state, props) => ({
    portfolioDetails: getPortfolioDetails(state, props),
    activeStep: getActiveStepFromParams(props.params),
    steps: getSteps(state),
    files: getFiles(state),
    uploadedFiles: getUploadedFiles(state),
    scanResult: getScanResult(state),
    uploadOption: getUploadOption(state),
    uploadDateTime: getUploadDateTime(state),
    uploadConfig: getUploadConfig(),
    overlappingDates: getOverlappingDates(state),
  }),
  actions: {
    ...Creators,
    addNotification: notificationsCreators.add,
    openDialog: DialogCreators.open,
  },
}))))
